import { useTranslation } from 'react-i18next'
import type { MeetingManagementTask } from '../types'

/**
 * "Sorumlular" hücresinin **tek kaynağı** — hem tablo hem kart görünümü bunu çizer (22.09.2026,
 * MR !229'daki inceleme bulgusu: mantık iki yerde ayrı yazılmıştı ve kart tarafı etiket stilini
 * kaybediyordu).
 *
 * <p><b>Etiketleme:</b> ana görevde "Ana Sorumlu: …" ve varsa "Süreç Destek Yöneticisi: …". Alt
 * görevde rol ayrımı gösterilmez, yalnız "Sorumlu: …" yazar — 2026-08-12 kullanıcı kuralı. Sunucu
 * alt görevde {@code secondaryResponsibles}'ı zaten boş döndürür; buradaki ayrım yalnız
 * <b>etiket metni</b> içindir.
 *
 * <p><b>`emptyMainText` neden var:</b> iki görünümün boş-değer geleneği farklıdır ve bu bilinçlidir.
 * Tabloda boş hücre çizilir (2026-09-16 kararı: çizgi, olmayan bir değeri varmış gibi gösteriyordu),
 * kartta ise diğer tüm alanlarla aynı biçimde tire yazılır — kartta etiket ile değer alt alta
 * durduğu için değerin hiç çizilmemesi "alan kayboldu" gibi okunuyor.
 */
export default function ResponsiblesLines({
  row,
  emptyMainText = null,
}: Readonly<{ row: MeetingManagementTask; emptyMainText?: string | null }>) {
  const { t } = useTranslation()
  const main = row.mainResponsible?.fullName?.trim() || emptyMainText
  const secondary = row.secondaryResponsibles.map((p) => p.fullName).filter(Boolean)

  if (!main && secondary.length === 0) return null

  const mainLabel = row.subTask
    ? t('meetingManagement.column.subTaskResponsibleLabel')
    : t('meetingManagement.column.mainResponsibleLabel')

  return (
    <div className="mm-responsibles">
      {main && (
        <div>
          <span className="mm-responsibles-label">{mainLabel}:</span> {main}
        </div>
      )}
      {secondary.length > 0 && (
        <div>
          <span className="mm-responsibles-label">
            {t('meetingManagement.column.secondaryResponsibleLabel')}:
          </span>{' '}
          {secondary.join(', ')}
        </div>
      )}
    </div>
  )
}
